import React from 'react';
import Icon from './Icon';
import {IconProps} from './IconProps';

export default function IconMerge({className, height, title}: IconProps) {
  return (
    <Icon className={className} height={height} title={title}>
      M17,20.41L18.41,19L15,15.59L13.59,17M7.5,8H11V13.59L5.59,19L7,20.41L13,14.41V8H16.5L12,3.5</Icon>
  );
}
